<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout wrap>
      <v-flex xs12 text-left>
        <span style="font-family: poppinssemibold; font-size: 22px">
          Sales Analysis</span
        >
      </v-flex>
    </v-layout>
    <v-layout wrap py-5>
      <v-flex xs12 sm6 md3 pt-2>
        <v-autocomplete
          outlined
          dense
          color="#8d8d8d"
          placeholder="Shop Name"
          v-model="sellerId"
          :items="sellerList"
          item-text="sellerid.shopName"
          item-value="sellerid._id"
          item-color="#FF1313"
          hide-details
          clearable
          class="text-left"
          label="Shop Name"
        >
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3 px-4 pt-2>
        <v-autocomplete
          v-model="uid"
          :items="customers"
          item-text="name"
          item-value="_id"
          item-color="#8d8d8d"
          color="#8d8d8d"
          outlined
          clearable
          dense
          label="customers"
        >
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3 px-4 align-self-center pt-2>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fromDate"
              label="From Date"
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fromDate"
            no-title
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6 md3 px-4 align-self-center pt-2>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="toDate"
              label="To Date"
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="toDate"
            no-title
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-layout wrap>
            <span style="font-size: 18px; font-weight: bold"
              >Total {{totalLength}} orders calculations</span
            >
          </v-layout>
          <v-layout wrap justify-start>
            <v-flex sm6 text-left>
              <span class="medium2 PM"
                >Total Amount:<span class="RB">
                  {{ total.totalamountreceived }}
                </span></span
              >
              <br />
              <span class="medium2 PM"
                >Total Commission for Pakt:
                <span class="RB">
                  {{ total.totalcommissionforpakt }}
                </span></span
              >
              <br />
              <span class="medium2 PM"
                >Total Amount to seller:
                <span class="RB">
                  {{ total.totalamounttoseller }}
                </span></span
              >
            </v-flex>
            <v-flex sm6 text-left>
              <span class="medium2 PM"
                >Total Parcel Charge:<span class="RB">
                  {{ total.totalparcelcharge }}
                </span></span
              ><br />
              <span class="medium2 PM"
                >Total Packing Charge:
                <span class="RB">
                  {{ total.totalpackingcharge }}
                </span></span
              >
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6>
          <v-layout wrap>
            <span style="font-size: 18px; font-weight: bold">
              Calculations of current page orders</span
            >
          </v-layout>
          <v-layout wrap justify-start>
            <v-flex sm6 text-left>
              <span class="medium2 PM"
                >Total Amount:<span class="RB">
                  {{ total1.totalamountreceived }}
                </span></span
              >
              <br />
              <span class="medium2 PM"
                >Total Commission for Pakt:
                <span class="RB">
                  {{ total1.totalcommissionforpakt }}
                </span></span
              >
              <br />
              <span class="medium2 PM"
                >Total Amount to seller:
                <span class="RB">
                  {{ total1.totalamounttoseller }}
                </span></span
              >
            </v-flex>
            <v-flex sm6 text-left>
              <span class="medium2 PM"
                >Total Parcel Charge:<span class="RB">
                  {{ total1.totalparcelcharge }}
                </span></span
              ><br />
              <span class="medium2 PM"
                >Total Packing Charge:
                <span class="RB">
                  {{ total1.totalpackingcharge }}
                </span></span
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-data-table
          style="overflow-x: auto"
          :headers="headers"
          :items-per-page="180"
          :items="orders"
          class="elevation-1"
          :hide-default-footer="true"
        >
          <template v-slot:[`item.date`]="{ item }">
            <span v-if="item.date">
              <!-- {{ formatDate(item.date) }} -->
              {{ momentTime(item.date) }}
            </span>
          </template>
          <template v-slot:[`item.amountreceived`]="{ item }">
            <span>
              <!-- {{ formatDate(item.date) }} -->
              {{ Number(item.amountreceived.toFixed(2)) }}
            </span>
          </template>
          <template v-slot:[`item.packingcharge`]="{ item }">
            <span>
              <!-- {{ formatDate(item.date) }} -->
              {{ Number(item.packingcharge.toFixed(2)) }}
            </span>
          </template>
          <template v-slot:[`item.parcelcharge`]="{ item }">
            <span>
              <!-- {{ formatDate(item.date) }} -->
              {{ Number(item.parcelcharge.toFixed(2)) }}
            </span>
          </template>
          <template v-slot:[`item.commissionforpakt`]="{ item }">
            <span>
              <!-- {{ formatDate(item.date) }} -->
              {{ Number(item.commissionforpakt.toFixed(2)) }}
            </span>
          </template>
          <template v-slot:[`item.amounttoseller`]="{ item }">
            <span>
              <!-- {{ formatDate(item.date) }} -->
              {{ Number(item.amounttoseller.toFixed(2)) }}
            </span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      currentPage: 1,
      limit: 50,
      pages: null,
      orders: [],
      appLoading: false,
      fromDate: null,
      toDate: null,
      menu1: false,
      menu2: false,
      total: {},
      headers: [
        {
          text: "SI No.",

          value: "slno",
          sortable: false,
        },
        { text: "Date & Time", sortable: false, value: "date", width: "120px" },
        {
          text: "Restaurant Name & Details",
          value: "seller.shopName",
          width: "120px",
          sortable: false,
        },
        {
          text: "Customer Name & Details ",
          value: "customername",
          width: "120px",
          sortable: false,
        },
        {
          text: "Invoice NO",
          align: "center",
          value: "invoiceno",
          width: "120px",
          sortable: false,
        },
        {
          text: "Items $ qnty",
          align: "center",
          value: "items",
          width: "180px",
          sortable: false,
        },
        {
          text: "Mode of Dispatch",
          sortable: false,
          align: "center",
          value: "modeofdispatch",
        },
        { text: "Mode of Payment", align: "center", value: "modeofpayment" },
        {
          text: "Delivery person Name",
          align: "center",
          value: "deliverypersonname",
          sortable: false,
        },
        {
          text: "Amount Received",
          sortable: false,
          align: "center",
          value: "amountreceived",
        },
        {
          text: "Packing Charge",
          sortable: false,
          align: "center",
          value: "packingcharge",
        },
        {
          text: "Parcel Charge",
          sortable: false,
          align: "center",
          value: "parcelcharge",
        },
        {
          text: "Commission for Pakt",
          align: "center",
          value: "commissionforpakt",
          sortable: false,
        },
        {
          text: "Amount to Seller",
          sortable: false,
          align: "center",
          value: "amounttoseller",
        },
      ],
      desserts: [],
      customers: [],
      sellerList: [],
      sellerId: null,
      uid: null,
      totalLength: null,
      total1: {
        totalamountreceived: 0,
        totalamounttoseller: 0,
        totalpackingcharge: 0,
        totalparcelcharge: 0,
        totalcommissionforpakt: 0,
      },
    };
  },
  mounted() {

//     if (localStorage.LS_ROUTE_KEY == "/OrderInfo") {

//       this.fromDate = localStorage.analyticsfromDate;
      
//        this.toDate = localStorage.analyticstoDate;
//  }

    this.getData();
    this.getUsers();
    this.getSellers();
    // if (this.fromDate) {
    //   this.fromDate.setDate(this.fromDate.getDate());
    //   this.fromDate = this.fromDate.toISOString().substr(0, 10);
    // }
    // if (this.toDate) {
    //   this.toDate.setDate(this.toDate.getDate());
    //   this.toDate = this.toDate.toISOString().substr(0, 10);
    // }
  },
  watch: {
    currentPage() {
      this.getData();
    },
    fromDate() {
      // if (this.fromDate == null)
      this.getData();
    },
    toDate() {
      if (this.fromDate != null) this.getData();
    },
    uid() {
      this.getData();
    },
    sellerId() {
      this.getData();
    },
  },
  methods: {
    momentTime(time) {
      var local = moment.utc(time).local().format("MMM-DD-YYYY h:mm A");
      return local;
    },

    getSellers() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.sellerList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getUsers() {
      axios({
        method: "POST",
        url: "/customers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          // role: "Customer",
          status: "Active",
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.customers = response.data.data;
            this.customers.forEach(function (itm) {
              if (itm.customerid)
                itm.name =
                  itm.customerid.firstName + " " + itm.customerid.lastName;
              else itm.name = "No Name";
            });
            // this.customers.unshift({ name: "All", _id: null });
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
       if (this.fromDate != null) {
          localStorage.setItem("analyticsfromDate", this.fromDate);
       }
        else{
        localStorage.setItem("analyticsfromDate", this.fromDate);
      }
        if (this.toDate != null) {
          localStorage.setItem("analyticstoDate", this.toDate);
       }
       else{
        localStorage.setItem("analyticstoDate", this.toDate);
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/all/sellers/order/reportgeneration",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: {
          limit: this.limit,
          page: this.currentPage,
          from: this.fromDate,
          to: this.toDate,
          uid: this.uid,
          sellerId: this.sellerId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // orders.push(
            //   {
            //     deliverypersonname:"huihuihi"

            //   }
            // )
            this.total = response.data.total;
            this.orders = response.data.data;
            for (var i = 0; i < this.orders.length; i++) {
              this.total1.totalamountreceived =
                this.total1.totalamountreceived + this.orders[i].amountreceived;
              this.total1.totalcommissionforpakt =
                this.total1.totalcommissionforpakt +
                this.orders[i].commissionforpakt;
              this.total1.totalamounttoseller =
                this.total1.totalamounttoseller + this.orders[i].amounttoseller;
              this.total1.totalparcelcharge =
                this.total1.totalparcelcharge + this.orders[i].parcelcharge;
              this.total1.totalpackingcharge =
                this.total1.totalpackingcharge + this.orders[i].packingcharge;
            }
            //  this.orders.forEach(function (itm) {
            //   this.total1.totalamountreceived=this.total1.totalamountreceived+itm.amountreceived
            //   console.log(itm.amountreceived)
            // });

            this.totalLength = response.data.totalLength;
            this.pages = response.data.totalPages;

            this.appLoading = false;
          } else {
            this.appLoading = false;
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>